<h2 mat-dialog-title>Ungespeicherte SMS-Texte</h2>
<mat-dialog-content
  >Beim Verlassen gehen Ihre ungespeicherten Änderungen
  verloren.</mat-dialog-content
>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Weiter bearbeiten</button>
  <button mat-button [mat-dialog-close]="true">Verlassen</button>
</mat-dialog-actions>
